<template>
  <div class="width-100">
    <div v-if="isMobile">
      <v-radio-group :value="selectedRating" class="ma-0 mt-2" :items="items" item-text="title" item-value="id" hide-details @change="handleChange">
        <div v-for="choice in items" :key="choice.id" class="csat-answer-container" @click="handleChange(choice.id)">
          <div class="d-flex flex-row align-start justify-start">
            <span
              class="choice-title"
              :class="{ 'font-weight-bold': choice.id === selectedRating }"
              :style="{ color: choice.id === selectedRating ? choice.color : '#6b7580' }"
              >{{ choice.title }}</span
            >
            <v-icon v-if="choice.id === selectedRating" class="ml-2" :color="choice.color" :size="24">{{ choice.icon }}</v-icon>
          </div>
          <v-radio class="pa-0 ma-0" :color="choice.color" :value="choice.id" hide-details> </v-radio>
        </div>
      </v-radio-group>
    </div>

    <div v-else>
      <div class="d-flex flex-row justify-center width-100 gap-24 my-6" @mouseover="handleMouseOverAllItems()" @mouseleave="handleMouseLeaveAllItems()">
        <div v-for="choice in reversedItems" :key="choice.id" class="csat-answer-item" @click="handleChange(choice.id)" @mouseover="handleMouseOver(choice.id)">
          <v-icon class="mb-6" :color="getColorByRating(choice)" size="40">{{ getStarIcon(choice) }}</v-icon>
          <v-icon class="mb-4" :color="getColorByRating(choice)">{{ choice.icon }}</v-icon>
          <span class="csat-text" :style="{ color: getColorByRating(choice) }">{{ choice.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CsatAnswer',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedRating: null,
      mouseIsHovering: false,
      mouseOverRating: null
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getAssets() {
      return this.GET_ASSETS
    },
    invalidAnswer() {
      return false
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    items() {
      return [
        {
          title: 'Muito satisfeito',
          id: 5,
          color: '#0A8533',
          icon: 'mdi-emoticon-outline'
        },
        {
          title: 'Satisfeito',
          id: 4,
          color: '#A0C460',
          icon: 'mdi-emoticon-happy-outline'
        },
        {
          title: 'Neutro',
          id: 3,
          color: '#F3AF00',
          icon: 'mdi-emoticon-neutral-outline'
        },
        {
          title: 'Insatisfeito',
          id: 2,
          color: '#F47F68',
          icon: 'mdi-emoticon-sad-outline'
        },
        {
          title: 'Muito insatisfeito',
          id: 1,
          color: '#E03210',
          icon: 'mdi-emoticon-angry-outline'
        }
      ]
    },
    reversedItems() {
      return [...this.items].reverse()
    }
  },
  watch: {
    question: {
      handler(newVal) {
        this.selectedRating = newVal.answers?.[0]
      },
      deep: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', [value])
    },
    getColorByRating(choice) {
      if (this.mouseIsHovering) {
        if (choice.id <= this.mouseOverRating) {
          return this.items.find(item => item.id === this.mouseOverRating).color
        }
      } else {
        if (choice.id <= this.selectedRating) {
          return this.items.find(item => item.id === this.selectedRating).color
        }
      }
      return '#c3c8cd'
    },
    getStarIcon(choice) {
      if (this.mouseIsHovering) {
        if (choice.id <= this.mouseOverRating) {
          return 'mdi-star'
        }
      } else {
        if (choice.id <= this.selectedRating) {
          return 'mdi-star'
        }
      }
      return 'mdi-star-outline'
    },
    handleMouseOver(value) {
      this.mouseOverRating = value
    },
    handleMouseOverAllItems() {
      this.mouseIsHovering = true
    },
    handleMouseLeaveAllItems() {
      this.mouseIsHovering = false
    }
  }
}
</script>

<style scoped lang="scss">
.csat-answer-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 24px;
  margin: 0;
}

.choice-title {
  font-size: 14px;
  font-weight: normal;
  color: #6b7580;
}

.width-100 {
  width: 100%;
}

.font-weight-bold {
  font-weight: bold;
}

.fixed-width {
  width: 92px;
}

.gap-24 {
  gap: 24px;
}

.csat-text {
  font-size: 16px;
  text-align: center;
  color: #c3c8cd;
}

.csat-answer-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 92px;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>
